import { jqUrlUtils } from 'javascripts/general_scripts';
jqUrlUtils();

export function captureImpression (original_url) {
  let tid = $.getSearchParam({param: 'tid'}); // $.getSearchParam is an extension from jqUrlUtils
  let impression_data = {
    original_url: original_url || location.href,
    referrer: document.referrer,
    promoted: window.PROMOTED_ID, // we need to access it as a property of window in case it hasn't been defined on this page
    fp: window.dataLayer[0].fp,
    tid
  };
  $.post('/impression', { impression_data });
}
